import './thumbnail-gallery'
import './table-of-contents'
import './cart-form'
import { createBundleDropdowns } from './bundle-dropdowns'

$.fn.Product = function() {
  let self = this
  self.product = self.find('.product')
  self.bar = self.find('.product-bar')
  self.cart_form = undefined

  self.find('.summary .accordion__item:first-child .accordion__header').attr('aria-expanded', 'true');
  self.find('.summary .accordion__item:first-child .js-accordion__panel')
  .css('max-height', 'none')
  .attr('aria-hidden', 'false');

  setTimeout(function() {
    self.find('.summary .accordion__item:first-child .js-accordion__panel')
    .css('max-height', self.find('.summary .accordion__item:first-child .accordion__content').outerHeight())
  }, 500)

  let accordion = self.find('.summary .js-accordion')
  accordion.find('.accordion__item .accordion__header').on('click', function() {
    let targetTop = accordion.offset().top - $('.header').height(),
    header = $(this),
    currentItem = header.closest('.js-accordion__item')
    if ($('.top-bar').length && $('.top-bar').is(':visible')) {
      targetTop -= $('.top-bar').height()
    }
    /* uncomment below to scroll to the right item instead of the whole accordion */
    // currentItem.prevAll('.js-accordion__item').each(function() {
    //   targetTop += $(this).find('.accordion__header').outerHeight(false)
    // })
    /* below it's called before switching aria-expanded, that's why the logic is reversed */
    if (header.attr('aria-expanded') === 'false' && (targetTop < $(window).scrollTop() || targetTop > $(window).scrollTop() - window.innerHeight / 2)) {
      $('body, html').scrollTo(targetTop - 32, 450, 4, 'easeInOutQuart')
    }
  })

  self.initialize_gallery = function() {
    /* Thumbnail gallery */
    $('.thumbnail-gallery').each(function() {
      $(this).ThumbnailGallery()
    })

    /* Fixed content */
    $('.single-product-page__preview-wrapper').each(function() {
      $(this).FixedContent({
        topBlocker: $('.product-bar'),
        bottomBlocker: $('.product-informations'),
        limitFromTop: -30,
        useTransform: true,
      })
    })
  }

  self.initialize_bar = function() {
    self.bar.find('.product-bar__title').append($('<span class="product_title entry-title"></span>').html($('h1').html()))
    if ($('table.variations, .attribute_value_configurable, .bundled_item_cart_content table.variations, input.bundled_product_checkbox[name^="bundle_selected_optional"]').length) {
      self.bar.find('.product-bar__add-to-cart').append('<a class="product-bar__view-options single_add_to_cart_button" href="#top">Choix des options</a>')
      self.bar.find('.product-bar__view-options').on('click', function(e) {
        e.preventDefault()
        $('body, html').scrollTo(0, 500, 6, 'easeInOutQuart')
      })
    } else {
      self.bar.find('.product-bar__add-to-cart').append(self.find('.summary form.cart').clone())
      self.bar.find('.single_add_to_cart_button').append($('<span class="price-display"></span>'))
      self.bar.find('form.cart').CartForm({
        main: self.bar.find('form.cart'),
        parent: self.bar.find('form.cart'),
      })
    }
  }

  self.initialize_bundle = function() {
    let $page = $('.single-product-page')

    /* Fix price display for optional products in bundles */
    if ($page.find('.bundle_button .from').length) {
      $page.find('.bundle_button .price-display').replaceWith($page.find('.bundle_wrap .bundle_price'))
    }

    /* Handle optional products visibility in bundle summary box */
    $page.find('input.bundled_product_checkbox[name^="bundle_selected_optional"]').each(function() {
      let $checkbox = $(this)
      let checkboxName = $checkbox.attr('name')
      let bundledItemId = checkboxName.replace('bundle_selected_optional_', '')
      let $bundleRow = $('.single-product-page__bundle--row[data-bundled-item-id="' + bundledItemId + '"]')

      // Set initial visibility based on checkbox state
      if ($checkbox.is(':checked')) {
        $bundleRow.fadeIn(300)
      }

      // Update visibility when checkbox changes
      $checkbox.on('change', function() {
        if ($(this).is(':checked')) {
          $bundleRow.fadeIn(300)
        } else {
          $bundleRow.fadeOut(5)
        }
      })
    })

    /* Retrieve existing selects */
    $page.find('.bundled_item_cart_content table.variations').each(function() {
      let $variation = $(this),
      $select = $variation.find('select'),
      $clone = $variation.clone(),
      $selectClone = $clone.find('select')
      $('.cart.bundle_data').prepend($clone)
      $selectClone.on('change', function() {
        $select.val($(this).val()).trigger('change')
      })
    })

    /* Update product names in bundle summary when variations change */
    $page.find('.bundled_item_cart_content table.variations select').each(function() {
      let $select = $(this)
      let $bundledItem = $select.closest('.bundled_product')
      let bundledItemId = $bundledItem.attr('class').match(/bundled_item_(\d+)/)[1]
      let $bundleRow = $('.single-product-page__bundle--row[data-bundled-item-id="' + bundledItemId + '"]')
      let $productName = $bundleRow.find('.single-product-page__bundle--name')
      let baseProductName = $productName.text().trim()

      // Store the base name if not already stored
      if (!$productName.data('base-name')) {
        $productName.data('base-name', baseProductName)
      }

      // Update name when variation changes
      $select.on('change', function() {
        let selectedValue = $(this).find('option:selected').text()
        let baseName = $productName.data('base-name')

        if (selectedValue && selectedValue !== 'Choisir une option') {
          $productName.text(baseName + ' – ' + selectedValue)
        } else {
          $productName.text(baseName)
        }
      })
    })

    /* Create bundle dropdowns using shared function */
    createBundleDropdowns($page, $('.cart.bundle_data'))
  }

  self.initialize_product = function() {
    self.find('.summary form.cart .quantity').after($('<span class="price-display"></span>'))
    self.cart_form = self.find('.summary form.cart').CartForm({
      main: self.find('.summary form.cart'),
      parent: self.find('.summary form.cart'),
    })
    // $.mlmi.mobile.add(function() {
    //   $('.single-product-page__product').find('.provenance-flash, .sale-flash').css('top', '')
    // }, function() {
    //   $('.single-product-page__product').find('.provenance-flash, .sale-flash').css('top', ($('.single-product-page__summary h1.product_title').outerHeight(false) + 22) + 'px')
    // })
  }

  self.initialize_scroll = function() {
    if (self.bar == undefined) {
      return
    }
    $.mlmi.scroll.add(function(top) {
      if (self.cart_form.length) {
        let formTop = self.cart_form.offset().top - top + self.cart_form.outerHeight(false) - parseFloat($('html').css('--total-header-height'))
        if (formTop < 0) {
          self.bar.addClass('product-bar--visible')
        } else {
          self.bar.removeClass('product-bar--visible')
        }
      }
    })
  }

  self.initialize_reviews = function() {
    const clampLines = 6
    const lineHeight = 1.33 * 14 // line-height * font-size

    $('.cr-comment-text .description').each(function() {
      let $description = $(this)
      let naturalHeight = $description[0].scrollHeight
      let clampedHeight = clampLines * lineHeight

      if (naturalHeight > clampedHeight + 10) {
        $description.addClass('is-clamped')
        $description.after('<span class="cr-read-more">' + gourmetsauvage_params.READ_MORE + '</span>')
      }
    })

    $(document).on('click', '.cr-read-more', function() {
      let $button = $(this)
      let $description = $button.siblings('.description')

      if ($description.hasClass('is-clamped')) {
        $description.removeClass('is-clamped')
        $button.text(gourmetsauvage_params.READ_LESS)
      } else {
        $description.addClass('is-clamped')
        $button.text(gourmetsauvage_params.READ_MORE)
      }

      $(window).trigger('resize')
    })
  }

  return function() {
    self.initialize_gallery()
    self.initialize_bar()
    self.initialize_product()
    self.initialize_bundle()
    self.initialize_scroll()
    self.initialize_reviews()
    return self
  }()
}
